import regulatory from "../../assets/icons/Regulatory.svg";
import analytical from "../../assets/icons/Analytical_Precision.svg";
import leadership from "../../assets/icons/Transformational_Leadership.svg";
import partnership from "../../assets/icons/Collaborative_Partnership.svg";
import integrity from "../../assets/icons/Integrity_Driven_Excellence.svg";
import growth from "../../assets/icons/Continuous_Growth.svg";

const values = [
    {
        img: regulatory,
        title: "Regulatory Foresight",
        desc: "We proactively monitor evolving regulatory landscapes to ensure compliance and strategic readiness.",
    },
    {
        img: analytical,
        title: "Analytical Precision",
        desc: "Our data-driven insights empower timely, informed decisions—executed with full accountability.",
    },
    {
        img: leadership,
        title: "Transformational Leadership",
        desc: "Through strong leadership, communication, and collaboration, we drive measurable performance improvements.",
    },
    {
        img: partnership,
        title: "Collaborative Partnership",
        desc: "We succeed by working hand-in-hand with our clients, delivering with dedication and reliability.",
    },
    {
        img: integrity,
        title: "Integrity-Driven Excellence",
        desc: "We help clients achieve their goals through ethical problem-solving and comprehensive, value-based solutions.",
    },
    {
        img: growth,
        title: "Continuous Growth",
        desc: "Our commitment to learning and evolving ensures we stay ahead of industry trends and challenges.",
    },
];

const DistinguishesUs = () => {
    return (
        <section className="bg-[#E6EBF1] py-12 px-6">

            <div className="text-center max-w-[var(--max-width)] mx-auto mb-12">
                <div className="relative inline-block ">
                    <h1 className="inline-block relative text-3xl md:text-4xl text-[#05326D] mb-4 font-normal text-[32px]">
                    What Distinguishes Us
                    <span className="absolute right-0 -bottom-2 w-[40px] border-b-[6px] border-[#B5AB28] rounded-[6px]"></span>
                    </h1>
                </div>
                <p className="text-[#05326D] font-semibold mt-2">
                    Core Values That Define Our Commitment to Excellence
                </p>
            </div>


            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[var(--max-width)] mx-auto">
                {values.map((item, idx) => (
                    <div
                        key={idx}
                        className="relative bg-blue-50 rounded-lg shadow-md border border-blue-500 p-3 text-left ">
                        <div className="absolute -top-8 right-6 ">
                            <img
                                src={item.img}
                                alt={item.title}
                                className="w-20 h-20 rounded-full p-2"
                            />
                        </div>
                        <h3 className="text-[#05326D] font-semibold mt-6">{item.title}</h3>
                        <p className="text-[#05326D] mt-2 text-sm">{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default DistinguishesUs;
